var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4991 27.6319C11.9134 27.0462 11.9134 26.0964 12.4991 25.5106L25.52 12.4898C26.1057 11.904 27.0555 11.904 27.6413 12.4898C28.2271 13.0756 28.2271 14.0253 27.6413 14.6111L14.6205 27.6319C14.0347 28.2177 13.0849 28.2177 12.4991 27.6319Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 27.5106C26.9143 28.0964 25.9646 28.0964 25.3788 27.5106L12.358 14.4898C11.7722 13.904 11.7722 12.9543 12.358 12.3685C12.9438 11.7827 13.8935 11.7827 14.4793 12.3685L27.5001 25.3893C28.0859 25.9751 28.0859 26.9248 27.5001 27.5106Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.eb41a4335e19111fa8d7e11a0166f78e.svg";
export { ForwardRef as ReactComponent };